import script from "./ModelTester.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelTester.vue?vue&type=script&setup=true&lang=js"

import "./ModelTester.vue?vue&type=style&index=0&id=16b01406&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b01406"]])

export default __exports__